var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":_vm.editarIteracion}},[_vm._v("\n      Editar\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }